import { CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import FlowDocuments from "views/admin/Admissions/AddAdmissions/applicationFlow/FlowDocuments";
import { fetchOtherEntryDocuments, saveOtherEntryDocuments } from "../otherEntryApi";

/**
 * Documents on a custom entry. Saved on change rather than with the account — this panel's other
 * fields ride the account's autosave, but a document that only exists in browser state until someone
 * remembers to save is a document that gets lost.
 */
const OtherEntryDocuments = ({ cadId, readOnly = false }) => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!cadId) return undefined;
    let cancelled = false;
    setLoading(true);
    fetchOtherEntryDocuments(cadId)
      .then((list) => {
        if (!cancelled) setDocuments(list);
      })
      .catch(() => {
        if (!cancelled) setDocuments([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [cadId]);

  const handleChange = async (next) => {
    const previous = documents;
    setDocuments(next);
    try {
      // The response carries freshly presigned urls, so the list the user sees stays openable.
      setDocuments(await saveOtherEntryDocuments(cadId, next));
    } catch (err) {
      setDocuments(previous);
      toast.error(err?.response?.data?.errorMessage || "Failed to save documents.");
    }
  };

  if (!cadId) {
    return null;
  }

  return (
    <div className="mt-3 pt-3 border-t border-app-border/70">
      <p className="text-[11px] font-semibold uppercase tracking-wide text-app-text-muted m-0 mb-2">
        Documents
      </p>
      {loading ? (
        <CircularProgress size={18} />
      ) : (
        <>
          <FlowDocuments documents={documents} onChange={handleChange} readOnly={readOnly} />
          {documents.length === 0 && (
            <Typography variant="caption" color="text.secondary">
              Receipts, invoices or anything else supporting this charge.
            </Typography>
          )}
        </>
      )}
    </div>
  );
};

export default OtherEntryDocuments;
